import React, {useEffect, useState} from 'react';
import {Portlet, PortletBody, PortletHeader, PortletHeaderToolbar} from "../../../components/Portlet";
import {Link} from "react-router-dom";
import { TouristServicesCreateRoute, TouristServicesEditRoute } from "../../routesConstants";
import DataTable from "../../../components/dataTable";
import {Tab, Tabs} from "react-bootstrap";
import ListOptions from "../components/ListOptions";
import numberFormat from '../../../helpers/numberFormat';
import SinkRateHawk from "../../counterparty/components/sinkRateHawk";
import OsvTable from "../components/OsvTable";
import {Helmet} from "react-helmet";
import SinkIWay from "../components/sinkIWay";
import SinkRustar from "../components/sinkRustar";

const readSavedQuery = () => {
  const raw = localStorage.getItem("tSQuery");
  if (!raw) return { standartSort: true };
  try {
    return JSON.parse(raw) || { standartSort: true };
  } catch (e) {
    localStorage.removeItem("tSQuery");
    return { standartSort: true };
  }
};

const TouristServicesList = () => {
  const memoryQuery = readSavedQuery();
  const memoryPage = Number(memoryQuery.page) || 0;
  const [query, setQuery] = useState(memoryQuery);

  useEffect(() => {
    if(localStorage.getItem("tSQuery")){
      localStorage.removeItem("tSQuery")
    }
  }, []);
  const [all, setAll] = useState(false)
  const [tabIndex, setTabIndex] = useState(window.location.hash?.slice(1) ||"home");
  const columns = [
    {
      Header: 'Туристы',
      accessor: 'paxes',
      Cell: ({value,row})=>(
        <Link to={TouristServicesEditRoute + row.original.id}
          onClick={()=>{
            localStorage.setItem("tSQuery",  JSON.stringify({...query, page:localStorage.getItem("page")}))
            console.log(localStorage.getItem("tSQuery"))
        }}>
          {value.map((t, i) => (<React.Fragment key={i}>{t}<br/></React.Fragment>))}
        </Link>
      )
    },

    {
      Header: 'Сумма (KZT)',
      accessor: 'summ',
      Cell: ({value})=>(<>{numberFormat(value)}</>)
    },
    {
      Header: 'Описание',
      accessor: 'description',
    },
    {
      Header: 'Покупатель',
      accessor: 'buyer',
    },
    {
      Header: 'Дата выписки',
      accessor: 'issueDate',
      Cell: ({value,row})=>(<>{value}</>)
    },
    {
      Header: "Оплачен/Выкуп",
      accessor: "paid",
      Cell: ({ value, row }) => {
        const foundInCash = row.original.foundInCash
        const foundCash = foundInCash?.found
        const totalServ = foundInCash?.total
        const cashColor = foundCash == null || totalServ == null
          ? "secondary"
          : foundCash === totalServ
            ? "success"
            : foundCash === 0
              ? "danger"
              : "warning"
        return (
          <div className={'d-flex justify-content-center gap-2'}>
            {!row.original.issuedWithoutDocs ?
              <i className="fa fa-file-text " style={{color: 'rgba(107,112,161,0.8)'}}></i> : value ? (
                <i className={"fa fa-check-circle text-success"}/>
              ) : (
                <i className={"fa fa-times-circle text-danger"}/>
              )}

            {row.original.issuedWithoutDocs &&
              <>
                /
                <i className={`fa fa-circle text-${cashColor}`}/>
              </>
            }
          </div>
        )
      }
    },
  ]
  const columsForPaiments = [
    {
      Header: 'Дата выписки',
      accessor: 'issueDate',
      Cell: ({value,row})=>(
        <Link to={TouristServicesEditRoute + row.original.id} target={'_blank'}>
        {value}
      </Link>)
    },
    {
      Header: 'Сумма',
      accessor: 'zacup',
      Cell: ({value})=>(<>{value.map((sum,i)=>{
        return <React.Fragment key={i}>{sum}{<br/>}</React.Fragment>
      })}</>)
    },
    {
      Header: 'Услуги',
      accessor: 'services',
      Cell: ({value})=>(<>{value.map((serv,i)=>{
        return <React.Fragment key={i}>{serv}<br/></React.Fragment>
      })}</>)
    },
    columns[2],
    {
      Header: 'Туристы',
      accessor: 'paxes',
      Cell: ({value,row})=>(
        <>
          {value.map((t, i) => (<React.Fragment key={i}>{t}<br/></React.Fragment>))}
        </>
      )
    },
    columns[3],
    columns[5],
  ]
  return (
    <>
      <Helmet>
        <title>Услуги</title>
      </Helmet>
      <Tabs
        variant="underline"
        id="controlled-tab-example"
        activeKey={tabIndex}
        onSelect={key => {
          setTabIndex(key)
          window.location.hash = key
        }}
      >
        <Tab eventKey="home" title="Список" >
          <ListOptions setQuery={setQuery} query={query} all={all} setAll={setAll} />
          <Portlet>
            <PortletHeader
              title={<div className={'d-flex align-items-center'}><h5>Список туристических услуг</h5>
                </div>}
              toolbar={
                <PortletHeaderToolbar>
                  <Link to={TouristServicesCreateRoute} className="btn btn-sm btn-primary">
                    <i className="la la-plus"/>
                    Добавить
                  </Link>
                </PortletHeaderToolbar>
              }
            />
            <PortletBody>
              <DataTable columns={query?.forPaiments ? columsForPaiments : columns}
                         search={query}
                         itemsPerPage={20}
                         url={`/api/touristServices/`}
                         all={all}
                         startPage={memoryPage}/>
            </PortletBody>
          </Portlet>
        </Tab>
        <Tab eventKey="sink" title="RateHawk"  className="tab-no-background">
          <SinkRateHawk active={tabIndex === "sink"}/>
        </Tab>
        <Tab eventKey="iWay" title="i´Way"  className="tab-no-background">
          <SinkIWay active={tabIndex === "iWay"}/>
        </Tab>
        <Tab eventKey="rustar" title="Rustar"  className="tab-no-background">
          <SinkRustar/>
        </Tab>
        <Tab eventKey="osv" title="Сводная таблица"  className="tab-no-background">
          <OsvTable/>
        </Tab>
      </Tabs>


    </>
  );
};

export default TouristServicesList;
